import { render, staticRenderFns } from "./AppInputLabel.vue?vue&type=template&id=6d3b39c0"
import script from "./AppInputLabel.vue?vue&type=script&lang=js"
export * from "./AppInputLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports